import { usePersistentStorageApi } from '~/common/contexts/PersistentStorageContext';
import { InceptPersistentStorageApi } from '../../types/InceptPersistentStorageApi';

export const useInceptPersistentStorageApi =
  usePersistentStorageApi<InceptPersistentStorageApi>;
